enum PermissionType {
    PortalRead = "Portal:Read",
    ThirdPartyAccountsRead = "ThirdPartyAccounts:Read",
    ThirdPartyAccountsManage = "ThirdPartyAccounts:Manage",
    ThirdPartyPaymentOrdersManage = "ThirdPartyPaymentOrders:Manage",
    InstitutionalAccountsRead = "InstitutionalAccounts:Read",
    InstitutionalAccountsManage = "InstitutionalAccounts:Manage",
    InstitutionalPaymentOrdersManage = "InstitutionalPaymentOrders:Manage",
    DepositAccountsRead = "CustomerAccounts:Read",
    DepositAccountsManage = "CustomerAccounts:Manage",
    DepositPaymentOrdersManage = "CustomerPaymentOrders:Manage",
    LendingAccountsRead = "LendingAccounts:Read",
    LendingAccountsManage = "LendingAccounts:Manage",
    ProductsRead = "Products:Read",
    ProductsManage = "Products:Manage",
    RateSourcesRead = "RateSources:Read",
    RateSourcesManage = "RateSources:Manage",
    AccountingRead = "Accounting:Read",
    AccountingManage = "Accounting:Manage",
    ReportsRead = "Reports:Read",
    ReportsManage = "Reports:Manage",
    UsersRead = "Users:Read",
    UsersManage = "Users:Manage",
    RolesRead = "Roles:Read",
    RolesManage = "Roles:Manage",
    InstitutionSettingsRead = "InstitutionSettings:Read",
    InstitutionSettingsManage = "InstitutionSettings:Manage",
    AppMediumsRead = "AppMediums:Read",
    AppMediumsManage = "AppMediums:Manage",
    WebhooksRead = "Webhooks:Read",
    WebhooksManage = "Webhooks:Manage",
}
export default PermissionType